import React, { useState } from "react";
// css comes in published_hw.css
import { Link, NavLink } from "react-router-dom";
import axios from "../../../../../axios";
import { Popup } from "semantic-ui-react";
import PublishedThreeDotPopup from "../ongoing_threeDot_ppup/PublishedThreeDotPopup";
import moment from "moment";
import PopupEndAssessemnt from "./PopupEndAssessemnt";
import { timeHelper, dateHelper } from "../../../../../Utils/datetime_helper";
import { BookText, CalendarDays } from "lucide-react";

const PublishAssessBox = ({
  assessment,
  setDeactiveProcess,
  getPublishedAssessment,
}) => {
  const { id, section_id, standard_id, subject_id, deadline, name } =
    assessment;

  const cardStyle = {
    "--subject-color": "#" + assessment?.subject_id?.subject_color,
  };
  //
  const [click, setClick] = useState(false);
  // const DateHelper = (a) => {
  //   const dateObj = new Date(a);
  //   // const day = dateObj.getUTCDate();
  //   // const month = dateObj.getUTCMonth() + 1;
  //   // const year = dateObj.getUTCFullYear();
  //   // const outputDateString = `${day}/${month}/${year}`;
  //   const outputDateString = moment(a).format("DD/MM/YYYY");
  //   return outputDateString;
  // };

  //Implement Api for end assessment
  const handleEndAssessment = async () => {
    let body = {
      status: "review",
    };
    if (assessment?.isAdaptive) {
      body.status = "completed";
    }
    try {
      let res = await axios.put(`/api/v1/assessment/updateStatus/${id}`, body);
      res && setDeactiveProcess((prev) => !prev);
      getPublishedAssessment();
    } catch (error) {
      console.log(error);
    }
  };
  const handleConfirm = () => {
    handleEndAssessment(); // Trigger API call on Yes
    setClick(false); // Hide the popup after confirmation
  };

  const handleCancel = () => {
    setClick(false); // Just hide the popup on No
  };

  const reduceSubjectName = (text, length) => {
    if (text.length < length) {
      return text;
    }
    return text.slice(0, length) + "...";
  };

  const subjectColor =
    "#" + (assessment?.subject_id?.subject_color || "000000");

  return (
    <>
      {assessment ? (
        <div
          className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
          style={{
            backgroundColor: "#FDEFE3",
            borderTop: `4px solid ${subjectColor}`,
            borderRight: "4px solid #8D4B28",
            borderBottom: "1px solid #8D4B28",
            borderLeft: "1px solid #8D4B28",
            borderRadius: "0.75rem",
          }}
        >
          {/* <div className="hw_published_card assessment_card" style={{ ...cardStyle }}> */}
          <div className="d-flex justify-content-between align-items-start mb-2">
            <NavLink
              to="/publishedStudentList"
              state={{ assesmentId: id, assessment: assessment }}
              className="text-dark fw-semibold text-decoration-none"
            >
              {`${standard_id?.name} - ${section_id?.name} | `}{" "}
              <span title={subject_id?.name} className="poppins-semibold">
                {reduceSubjectName(subject_id?.name, 18)}
              </span>
            </NavLink>

            {/* <Popup 
              trigger={
                <img
                  src="/images/menu-dots-vertical 1.svg"
                  className="hw_card_three_dot"
                  alt=""
                />
              }
              content={
                <div className="hw_popup_box_size">
                  <PublishedThreeDotPopup
                    assessmentId={id}
                    setDeactiveProcess={setDeactiveProcess}
                  />
                </div>
              }
              on="click"
              hideOnScroll
              position="bottom right"
            /> */}
          </div>
          <NavLink
            to="/publishedStudentList"
            state={{ assesmentId: id, assessment: assessment }}
            className="text-dark fw-semibold text-decoration-none"
          >
            <div className="d-flex align-items-center mb-1">
              <BookText size={16} className="me-2 text-dark" />
              <div className=" text-truncate poppins-semibold" title={name}>
                {reduceSubjectName(name, 30)}
              </div>
            </div>
            {assessment.isAdaptive && (
              <span
                style={{
                  padding: "7px 12px",
                  position: "absolute",
                  top: "23px",
                  right: "3%",
                  borderRadius: "6px",
                }}
              >
                <img
                  src="/images/adaptiveImg.png"
                  alt="img"
                  style={{ width: "70px" }}
                />
              </span>
            )}

            {assessment.autoEvalEnabled && (
              <span
                style={{
                  padding: "7px 12px",
                  position: "absolute",
                  top: "20px",
                  right: "3%",
                  borderRadius: "6px",
                }}
              >
                <img
                  src="/images/auto-eva.png"
                  alt="img"
                  style={{ width: "45px" }}
                />
              </span>
            )}
          </NavLink>

          <div
            className="d-flex align-items-center justify-content-between text-muted"
            style={{ fontSize: "0.875rem" }}
          >
            <div className="d-flex align-items-center">
              <CalendarDays size={16} className="me-2 text-dark" />
              <div className="d-flex flex-column">
                <span className="me-1">Scheduled On:</span>
                <div
                  className="d-flex justify-content-between align-items-center "
                  style={{ width: "100%" }}
                >
                  <span className=" text-dark">
                    {" "}
                    {dateHelper(assessment?.schedule_date || "")}
                    {" - "}
                    {timeHelper(assessment?.schedule_time || "")}
                  </span>
                </div>
              </div>
            </div>
            <button
              onClick={() => setClick(true)}
              style={{
                borderRadius: "6px",
                letterSpacing: "0.6px",
                padding: "5px 5px",
                fontWeight: 600,
                fontSize: "13px",
                lineHeight: "16px",
                backgroundColor: "#f77f00",
                color: "#ffffff",
                cursor: "pointer",
                border: "none",
                outline: "none",
                boxShadow: "2px 1px 3px rgb(140, 140, 140)",
              }}
            >
              End
            </button>
          </div>

          {click && (
            <PopupEndAssessemnt
              setClick={setClick}
              handleConfirm={handleConfirm}
              handleCancel={handleCancel}
            />
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default PublishAssessBox;
